/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * View для отображения списка валют в попапе города
   */
  app.NewCurrencySelectListView = app.CurrencySelectListView.extend({
    events: {
        'click .head-currency': 'choiceCurrency'
    },
    /**
     * Выбранная валюта, используется для применения валюты через роутер
     */
    chosenCurrency: null,
    isNewPopup: true,
    additionalOptions: ['router'],
    router: null,
    /**
     * @inheritdoc
     */
    run: function () {
      app.CurrencySelectListView.prototype.run.apply(this, arguments);
      app.CurrencySelectListView.prototype.render.apply(this, arguments);
      if (!this.router) {
        this.listenToOnce(Backbone, 'router:inited', function (router) {
          this.router = router;
        });
      }
      this.listenTo(Backbone, 'apply-currency', this.applyCurrency);
    },

    /**
     * Сброс валюты
     */
    reset: function () {
      this.render();
      this.chosenCurrency = null;
    },

    /**
     * Изменить валюту
     * @param {jQuery.Event} event событие
     */
    choiceCurrency: function(event) {
      var target = $(event.currentTarget),
        currency;
      if (target.length) {
        this.$('.head-currency_selected').removeClass('head-currency_selected');
        target.addClass('head-currency_selected');
        currency = $(target).children('a').data('currency');
        this.chosenCurrency = currency;
      }
    },

    /**
     * Применение валюты
     */
    applyCurrency: function () {
      if (this.chosenCurrency) {
        this.model.setCurrent(this.chosenCurrency);
        _.merge(app.currentCurrency, this.model.getCurrent().toJSON());
        Backbone.trigger('change-currency');
        if (this.router) {
          this.router.navigate(
            this.router.getPathFragment(),
            {
              trigger: true,
            },
            {
              currency: this.chosenCurrency,
            }
          );
        } else {
          var urlParams = _.extend(app.helpers.UrlHelper.getUrlParameters(), { currency: this.chosenCurrency }),
            url = app.helpers.UrlHelper.to(app.helpers.UrlHelper.getPathname(), [], urlParams);
          if (window.location.hash.length) {
            url += window.location.hash;
          }
          app.helpers.RedirectHelper.locationAssign(url);
        }
      }
    }
  });
})(jQuery);

}.call(window));